import React from 'react';
import history from '../../auth/history';
import FollowButton from '../Shared/FollowButton';

export default function ShowDetails(props) {
  const followerCount = (props.show.followers && props.show.followers.length) || 0;
  const show = props.show;
  const showImage =
    show.images && show.images.medium
      ? show.images.medium
      : show.images && show.images.thumbnail
      ? show.images.thumbnail
      : show.imageUrl;

  function redirectToShow() {
    history.push(`/${props.show.id}`);
  }

  function renderBreadcrumbs() {
    return (
      <div>
        <a className='link' href='/'>
          Home
        </a>
        <span>> </span>
        <a className='link' href={`/${props.show.id}`}>
          {props.show.title}
        </a>
      </div>
    );
  }

  return (
    <div className='show-details-container'>
      <div className='breadcrumbs'>{props.show.title && renderBreadcrumbs()}</div>
      <div className='show-detail-bottom'>
        <div className='show-image-container'>
          <a href={`/${props.show.id}`}>
            <img src={showImage} width={120} className='show-image' alt='' />
          </a>
        </div>
        <div className='show-details'>
          <a href={`/${props.show.id}`}>
            <h1 className='show-title'>{props.title || props.show.title}</h1>
          </a>
          {!!props.show.author && <h2 className='show-author'>{`Author: ${props.show.author}`}</h2>}
          <div className='show-counts'>
            {!props.minView && (
              <div className='follow-counts counts'>
                <div className='follower-count'>{`Followers: ${followerCount}`}</div>
              </div>
            )}
            <div className='episode-count counts'>
              {!!props.show.episodeCount &&
                `Episodes: ${props.show.episodeCount === 300 ? '300+' : props.show.episodeCount}`}
            </div>
          </div>
          {!props.minView ? (
            <FollowButton
              user={props.user}
              isFollowing={props.isFollowing}
              toggleLoginModal={props.toggleLoginModal}
              unfollow={props.unfollowShow}
              follow={props.followShow}
            />
          ) : (
            <a href={`/${props.show.id}`}>
              <div className='login-to-follow-btn'>Listen on Clipps</div>
            </a>
          )}
          {props.show.categories && (
            <div className={`category-container ${!props.show.author && 'no-author'}`}>
              {props.show.categories.map((category, index) => {
                return (
                  <div className='category-pill' key={index}>
                    {category}
                  </div>
                );
              })}
            </div>
          )}
          {!props.minView && (
            <div className={`links-container`}>
              <div>
                <a href={props.show.feedUrl} target='_blank' rel='noopener noreferrer'>
                  <i className='fad fa-rss-square' data-tip='RSS Feed' />
                </a>
                <a href={`mailto:${props.show.ownerEmail}`} target='_blank' rel='noopener noreferrer'>
                  <i className='fad fa-envelope-square' data-tip='Email Show' />
                </a>
                <a href={props.show.showLink} target='_blank' rel='noopener noreferrer'>
                  <i className='fad fa-external-link-square' data-tip='Website' />
                </a>
                <a href={`/l/${props.show.id}`} rel='noopener noreferrer'>
                  <i className='fad fa-share-alt-square' data-tip='Share Links' />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
